<div>
  <h1 class="mt-5">{{ 'authentication.call-us.title' | translate: lang }}</h1>
  <p>{{ 'authentication.call-us.message' | translate: lang }}</p>
</div>
